import { CartButton } from "@omni/components/components/Navigation/Buttons/CartButton/cartButton";

import { HeaderButtonComponent } from "@/components/Navigation/Buttons/HeaderButton/headerButton.component";

export const CartButtonComponent = () => {
    const { headerButtonProps } = CartButton.useContext();

    return (
        <HeaderButtonComponent
            {...headerButtonProps}
            hideChevron={true}
        >
            <CartButton.Content />
        </HeaderButtonComponent>
    );
};
